import "../vendor/lazysizes.min.js";

const global = () => {

    window.onload = function () {
        jQuery(".pieces-slider__slider ").slick({
            infinite: true,
            slidesToShow: 4,
            dots: false,
            nextArrow: `<button type="button" class="slick-arrow slick-next"><i class="fas fa-fw fa-caret-right"></button>`,
            prevArrow: `<button type="button" class="slick-arrow slick-prev"><i class="fas fa-fw fa-caret-left"></button>`,

            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: false,
                    },
                },
                {
                    breakpoint: 375,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                    },
                },
            ],
        });
    }

}

export default global